export default "<p>logs-digicod works!</p>\n"